<span mat-dialog-title>
  {{ 'Admins.Select.Title' | translate: locale.language }}
</span>

<div mat-dialog-content>
  @if (adminsLoading()) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }
  <mat-form-field class="full-width" appearance="outline">
    <mat-label>{{ 'Admins.Select.Search' | translate: locale.language }}</mat-label>
    <input matInput [formControl]="searchControl" />
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>

  <table mat-table [dataSource]="dataSource" [ngClass]="{ hidden: !page().length }">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>{{ 'Name' | translate: locale.language }}</th>
      <td mat-cell *matCellDef="let row">{{ row.firstName }} {{ row.lastName }}</td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      class="table-row"
      (click)="onSelect(row)"
      (keydown.enter)="onSelect(row)"
      tabindex="0"
      *matRowDef="let row; columns: displayedColumns"
    ></tr>
  </table>

  @if (!page().length) {
    <span class="no-results">
      {{ 'Admins.Select.NoResults' | translate: locale.language }}
    </span>
  }
  <mat-paginator
    [pageSizeOptions]="[10, 25, 50, 100]"
    [pageSize]="page().pageSize"
    [length]="page().length"
    (page)="onPageChange($event)"
    [showFirstLastButtons]="true"
    [ngClass]="{ hidden: page().length <= page().pageSize }"
  ></mat-paginator>
</div>
